import React from 'react';
import { Routes, Route } from 'react-router-dom';

import DashboardPage from './Dashboard';
import UsersPage from './Users';
import CoursesPage from './Courses';

const Admin = () => {
  return (
    <>
      <Routes>
        <Route path='' exact element={<DashboardPage />} />
        <Route path='users/*' element={<UsersPage />} />
        <Route path='courses/*' element={<CoursesPage />} />
      </Routes>
    </>
  );
};

export default Admin;
